
export const isNullOrUndefined = (val: any) => {
    return val === undefined || val === null;
}

export const isDefined = (val: any) => {
    return val !== null && val !== undefined;
}

export const isFunction = (val: any) => {
    return typeof val === 'function';
}


export const isNumber = (val: any) => {
    return typeof val === 'number' && !isNaN(val);
}

export const isInteger = (val: any) => {
    return isNumber(val) && val % 1 === 0;
}

export const isString = (val: any) => {
    return typeof val === 'string';
}

export const isObject = (val: any) => {
    return val === Object(val);
}

// Simply checks if the object is an instance of a date
export const isDate = (val: any) => {
    return val instanceof Date;
}

export const isArray = (val: any) => {
    return {}.toString.call(val) === '[object Array]';
}

export const isBoolean = (val: any) => {
    return typeof val === 'boolean';
};

export const isNumericality = (value: any, options = { strict: true, onlyInteger: true }) => {

    // Strict will check that it is a valid looking number
    if (isString(value) && options.strict) {
        var pattern = "^(0|[1-9]\\d*)";
        if (!options.onlyInteger) {
            pattern += "(\\.\\d+)?";
        }
        pattern += "$";

        if (!(new RegExp(pattern).test(value))) {
            return false;
        }
    }

    // Coerce the value to a number - strings is not allowed.
    if (isString(value)) {
        value = +value;
    }

    // If it's not a number we shouldn't continue since it will compare it.
    if (!isNumber(value)) {
        return false;
    }

    // Same logic as above, sort of. Don't bother with comparisons if this
    // doesn't pass.
    if (options.onlyInteger && !isInteger(value)) {
        return false;
    }

    return true;
}



export const isEmpty = (val: any) => {

    // Null and undefined are empty
    if (isNullOrUndefined(val)) {
        return true;
    }

    // functions are non empty
    if (isFunction(val)) {
        return false;
    }

    // Whitespace only strings are empty
    if (isString(val)) {
        const regexpt = new RegExp('^\s*$');
        return regexpt.test(val);
    }

    // For arrays we use the length property
    if (isArray(val)) {
        return val.length === 0;
    }

    // Dates have no attributes but aren't empty
    if (isDate(val)) {
        return false;
    }

    // If we find at least one property we consider it non empty
    if (isObject(val)) {
        for (let attr in val) {
            return false;
        }
        return true;
    }

    return false;
}

export const isEqualCaseInsensitive = (v1: string, v2: string) => {
    if (isNullOrUndefined(v1) || isNullOrUndefined(v2)) {
        return v1 === v2;
    }
    return v1.toLocaleLowerCase() === v2.toLocaleLowerCase();
}

export const isNotEqualCaseInsensitive = (v1: string, v2: string) => {
    if (isNullOrUndefined(v1) || isNullOrUndefined(v2)) {
        return v1 !== v2;
    }
    return v1.toLocaleLowerCase() !== v2.toLocaleLowerCase();
}

